import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DashboardImpersonationService } from 'src/app/core/services/dashboard-impersonation.service';

const IMPERSONATE_USER_HEADER = 'X-Impersonate-User-Id';
const DASHBOARD_V2_PATH = '/api/dashboard/v2/';

@Injectable()
export class DashboardImpersonationInterceptor implements HttpInterceptor {
  constructor(private readonly _dashboardImpersonationService: DashboardImpersonationService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const impersonatedUserId = this._dashboardImpersonationService.impersonatedUserId;
    if (!impersonatedUserId || !this.isDashboardRequest(request)) {
      return next.handle(request);
    }

    return next.handle(request.clone({
      setHeaders: {
        [IMPERSONATE_USER_HEADER]: impersonatedUserId
      }
    }));
  }

  private isDashboardRequest = (request: HttpRequest<unknown>): boolean => {
    return request.url.toLowerCase().includes(DASHBOARD_V2_PATH);
  };
}
